import React from 'react';
import PropTypes from 'prop-types';
import { HeroImageSources } from './HeroImageSource';

import './HeroImage.less';

const CNAME = 'HeroImage';

class HeroImage extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    require('object-fit-images')();
  }

  render() {
    const { children, treatments, title } = this.props;
    return (
      <div className={CNAME} >
        <picture className={`${CNAME}__picture`}>
          <HeroImageSources treatments={treatments} title={title} />
        </picture>
        {children}
      </div>
    );
  }
}

HeroImage.propTypes = {
  treatments: PropTypes.arrayOf(PropTypes.shape({
    defaultImg: PropTypes.bool.isRequired,
    href: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
    media: PropTypes.string.isRequired
  })).isRequired,
  title: PropTypes.string
};

export default HeroImage;
